import React from 'react';
import { QuestionAnswerPropType } from './QuestionAnswer.types';
import FaqList from '../../../faq/components/FaqList/FaqList';
var defaultProps = {
  questions: [],
  className: 'question-answer'
};
export default function QuestionAnswer(_ref) {
  var questions = _ref.questions,
    className = _ref.className;
  var faqs = questions.map(function (_ref2) {
    var text = _ref2.text,
      mainAnswer = _ref2.mainAnswer;
    var answer = mainAnswer.text;
    return {
      question: text,
      answer: answer
    };
  });
  return /*#__PURE__*/React.createElement(FaqList, {
    faqs: faqs,
    className: className
  });
}
QuestionAnswer.defaultProps = defaultProps;